import { render, staticRenderFns } from "./notaQuirurgica.vue?vue&type=template&id=42df1582&scoped=true&"
import script from "./notaQuirurgica.vue?vue&type=script&lang=js&"
export * from "./notaQuirurgica.vue?vue&type=script&lang=js&"
import style0 from "./notaQuirurgica.vue?vue&type=style&index=0&id=42df1582&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42df1582",
  null
  
)

export default component.exports